import { EProjectPlatform, IBaseConfigs } from './types';

const webConfigs: IBaseConfigs = {
  baseURL: '',
  apiDomain: '',
  apiDomainFallback: '',
  staticDomain: '',
  staticDomainFallback: '',
  chartDomain: `/chart`,
  platform: EProjectPlatform.WEB,
  routePathPrefix: `/${APP_PATH}`,
  socketPathPrefix: `//${location.host}`
};

export default webConfigs;
